module.exports = "<h5>Order Approval Pending...</h5>\n<button (click)=\"simulate()\" class=\"btn btn-tessco float-right\">Simulate Order Approval</button>\n\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-approval/order-approval.component.html
// module id = ../../../../../src/app/order-approval/order-approval.component.html
// module chunks = main